import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import jaJson from './locales/ja.json';

i18n.use(initReactI18next).init({
    resources: {
        ja: { translation: jaJson },
    },
    lng: 'ja',
    interpolation: { escapeValue: false },
    fallbackLng: false,
    returnEmptyString: false,
});

// eslint-disable-next-line import/no-default-export
export default i18n;
